import { UpsellContext } from '@ecosystem/newron-core/page/types';
import { UPSELL_QUALTRICS_BFF_ENDPOINT, UPSELL_ANALYTICS_BFF_ENDPOINT } from '../lib/constants';

export const getUpsellContext = (): UpsellContext => {
  return { upsellQualtricsURL: UPSELL_QUALTRICS_BFF_ENDPOINT, upsellAnalyticsURL: UPSELL_ANALYTICS_BFF_ENDPOINT };
};
